module.exports = __webpack_public_path__ + "static/media/science_category.0982d8e0.jpg";